import { initTranslations } from 'translations';

const loadTranslations = async (): Promise<void> => {
  await initTranslations();
};

export default loadTranslations;
